import React from 'react';
import styles from './LoginPasswordLost.module.css';
import useForm from '../Hooks/useForm';
import Input from '../Form/Input';
import { PASSWORD_LOST } from '../../api';
import Modal from 'react-modal';
import { useNavigate } from 'react-router-dom';

const LoginPasswordLost = () => {
  const cpf = useForm('cpf');
  const urlRecuperar = 'https://konectasaude.com.br/resetar';
  const [passChanged, setPassChanged] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const el = null;
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    if (cpf.validate()) {
      const { url, options } = PASSWORD_LOST({
        cpf: cpf.value,
        linkRecuperar: urlRecuperar,
      });

      try {
        const response = await fetch(url, options);
        const text = await response.text(); // pega a resposta como texto completo

        if (response.ok) {
          setMessage(text); // salva a mensagem completa (ex: "Email de recuperação enviado com sucesso para :email@exemplo.com")
          setPassChanged(true); // abre o modal
        } else {
          console.error('Erro na requisição:', text);
        }
      } catch (error) {
        console.error('Erro ao enviar requisição:', error);
      }
    }
  }

  function handleCloseModal() {
    setPassChanged(false);
    navigate('/');
  }

  return (
    <div className={styles.containerForm}>
      <Modal
        appElement={el}
        className={styles.modal}
        isOpen={passChanged}
        onRequestClose={() => handleCloseModal()}
        ariaHideApp={true}
      >
        <h2>
          Email para redefinição de senha enviado com sucesso
          <span>!</span>
        </h2>
        <p>{message.replaceAll('"', '')}</p>
        <button onClick={() => handleCloseModal()}>Fechar</button>
      </Modal>
      <h1>
        Digite seu CPF para a recuperação de senha
        <span className={styles.ponto}>.</span>
      </h1>
      <form onSubmit={handleSubmit} className={styles.form}>
        <Input
          name="cpf"
          type="text"
          label="CPF"
          placeholder="Digite seu CPF aqui..."
          {...cpf}
        />
        {/* <p className={styles.aviso}>
          *Deve ser o mesmo e-mail cadastrado anteriormente.
        </p> */}
        <button>ENVIAR</button>
      </form>
    </div>
  );
};

export default LoginPasswordLost;
